import { render, staticRenderFns } from "./EducationContractDocumentPreview.vue?vue&type=template&id=0334588a&scoped=true&"
import script from "./EducationContractDocumentPreview.vue?vue&type=script&lang=ts&"
export * from "./EducationContractDocumentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0334588a",
  null
  
)

export default component.exports